import { isBefore, startOfDay } from "date-fns"
import * as Yup from "yup"

type editScheduleValidation = Yup.AnyObjectSchema

export const useEditScheduleValidation = (): editScheduleValidation => {
  return Yup.object({
    scanLevel: Yup.string().required().default(""),
    scheduleDate: Yup.string()
      .required("Please enter a date.")
      .default("")
      .test("dateIsValid", "Date is not valid.", (value) => {
        if (!value) return false
        return !isBefore(startOfDay(new Date(value)), startOfDay(new Date()))
      }),
    dayOfMonth: Yup.number()
      .min(1, "Not a valid day of the month.")
      .max(31, "Not a valid day of the month."),
  })
}
